import type { ColDef, ICellRendererParams } from 'ag-grid-community';
import SearchVolumeChart from '@/app/common/components/CellRenderers/SearchVolumeChart';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import numberHumanizer from '@/helpers/numberHumanizer';
import timeStampToDate from '@/helpers/timeStampToDate';
import { getColor, isFirstRow, isLastRow } from '@/helpers/utils';
import { commonTooltips } from '@/app/common/tooltip/commonTooltips';
import type {
  RelatedKeywordItem,
  RelatedKeywordTrendSearchVolume
} from '@/app/KeywordResearch/types/keywordRelatedApiTypes';

type RelatedColumn = ColDef<RelatedKeywordItem> & {
  searchable?: boolean;
  title?: string;
  type?: string;
  noFilter?: boolean;
};

export const relatedColumnsConfig: RelatedColumn[] = [
  {
    field: 'related',
    type: 'string',
    title: 'کلمه',
    flex: 1,
    minWidth: 300,
    searchable: true
  },
  {
    field: 'importance',
    type: 'number',
    title: 'میزان اهمیت',
    width: 130,
    searchable: true,
    cellRenderer: (params: ICellRendererParams<RelatedKeywordItem>) => (
      <>
        {!params.data?.updated_at ? (
          <HelpTooltip
            icon={['fa', 'info-circle']}
            html={
              <p style={{ textAlign: 'right' }}>
                این داده بعد از ثبت نام به صورت خودکار بین ۲۴ تا ۴۸ ساعت به‌روز
                میشه.
              </p>
            }
          />
        ) : (
          params.value
        )}
      </>
    )
  },
  {
    field: 'search_volume_miztols',
    type: 'number',
    title: 'میزان جستجو',
    width: 130,
    searchable: true,
    cellRenderer: (params: ICellRendererParams<RelatedKeywordItem>) => (
      <>
        {!params.data?.updated_at ? (
          <HelpTooltip
            icon={['fa', 'info-circle']}
            html={
              <p style={{ textAlign: 'right' }}>
                این داده بعد از ثبت نام به صورت خودکار بین ۲۴ تا ۴۸ ساعت به‌روز
                میشه.
              </p>
            }
          />
        ) : !params.value ? (
          <HelpTooltip html={commonTooltips.searchVolume} />
        ) : (
          numberHumanizer(params.value)
        )}
      </>
    )
  },
  {
    field: 'trend_search_volume',
    sortable: false,
    type: 'array',
    title: 'روند جستجو',
    width: 120,
    cellStyle: {
      textAlign: 'center',
      margin: '0px'
    },
    cellClass: 'over-flow',
    // noFilter: true,
    // searchable: false,

    cellRenderer: (params: ICellRendererParams<RelatedKeywordItem>) => {
      const trend = params.value as RelatedKeywordTrendSearchVolume | undefined;
      return !params.data?.updated_at ? (
        <HelpTooltip
          icon={['fa', 'info-circle']}
          html={
            <p style={{ textAlign: 'right' }}>
              این داده بعد از ثبت نام به صورت خودکار بین ۲۴ تا ۴۸ ساعت به‌روز
              میشه.
            </p>
          }
        />
      ) : trend ? (
        <SearchVolumeChart
          count={22}
          isFirstRow={isFirstRow(params)}
          isLastRow={isLastRow(params)}
          dates={trend.update_dates}
          series={[
            {
              name: 'روند جستجو',
              data: trend.search_volumes.map((value, i) => ({
                name: String(trend.update_dates[i]),
                value: value,
                itemStyle: {
                  color: getColor('navbar-vertical-default-link-active-color')
                }
              }))
            }
          ]}
        />
      ) : (
        ''
      );
    }
  },
  {
    field: 'words_count',
    type: 'number',
    title: 'طول',
    width: 85,
    searchable: true
  },
  {
    field: 'inserted_at_timestamp',
    type: 'string',
    title: 'تاریخ درج',
    width: 150,
    noFilter: true,
    searchable: true,
    valueFormatter: params =>
      timeStampToDate(Number(params.value)).slice(8).toPersianDigit()
  }
];
